module.exports = __webpack_public_path__ + "static/media/getnet_profile.1579ace8.png";